/**
 * Legacy wrapper around useInferencePricing that reads from useInferenceFormStore.
 * Used by old-style inference forms where activeMode, activeForm, and refinement data
 * live in the Zustand store. New composer-based forms call useInferencePricing directly
 * with explicit props instead.
 */
import { useShallow } from "zustand/react/shallow";

import { useInferenceFormStore } from "@/components/inference-forms/state/hook";

import { useInferencePricing } from "./useInferencePricing";

export const useInferencePricingLegacy = () => {
  const { activeMode, activeForm } = useInferenceFormStore(
    useShallow((state) => ({
      activeMode: state.activeMode,
      activeForm: state.activeForm,
    })),
  );

  return useInferencePricing({
    activeMode,
    activeForm: activeForm ? { control: activeForm.control } : null,
  });
};
